<template>
  <section class="work" id="work">
    <div class="container">
      <div class="row">
        <div class="col-md-8 offset-md-2 text-center m-auto">
          <div class="section-title">
            <h2>كيفية عمل حلقة الدردشة</h2>
            <img
              src="../../assets/images/title-line.png"
              alt="white-line"
              class="img-fluid"
            />
            <p>
              أنا آسف ، أنا آسف ، أنا آسفة ، أنا سعيد بالنخبة المتشبهة بالديون.
              ريم الاتحاد الافريقي تيم متعة أعمى! الفريق عمل و متعة أعمى
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 text-center">
          <div class="process-box">
            <img src="../../assets/images/icon/1.png" alt="" />
            <h3>تحميل التطبيق</h3>
            <p>
              أبجد هوز دولور الجلوس امات، مينيابوليس الجامعية إيليت. لم تواجه أي
              من لنا من فضلك، والكراهية،
            </p>
            <img src="../../assets/images/icon/1.png" alt="" class="bg-icon" />
          </div>
        </div>
        <div class="col-lg-4 text-center">
          <div class="process-box">
            <img src="../../assets/images/icon/2.png" alt="" />
            <h3>ربط الناس</h3>
            <p>
              أبجد هوز دولور الجلوس امات، مينيابوليس الجامعية إيليت. لم تواجه أي
              من لنا من فضلك، والكراهية،
            </p>
            <img src="../../assets/images/icon/2.png" alt="" class="bg-icon" />
          </div>
        </div>
        <div class="col-lg-4 text-center">
          <div class="process-box">
            <img src="../../assets/images/icon/3.png" alt="" />
            <h3>يتمتع التطبيق</h3>
            <p>
              أبجد هوز دولور الجلوس امات، مينيابوليس الجامعية إيليت. لم تواجه أي
              من لنا من فضلك، والكراهية،
            </p>
            <img src="../../assets/images/icon/3.png" alt="" class="bg-icon" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "Work",
};
</script>
